<!--
    校区管理-学生管理-上课统计
    功能：展示班级学生上课记录
    组件:AppList、AppSearch
-->
<template>
  <div class="teacher_statistics">
    <div class="total clearfix">
      <span>{{ name }}学生</span>
      <span>手机号：{{ mobile }}</span>
      <el-button class="class_btn" type="primary" size="mini" v-if="$permissions('school_student_list_classes')" @click="StudentClass()">我的班级</el-button>
    </div>
    <AppList
      ref="list_live"
      :list.sync="list"
      title=""
      :api="`/api/liveroom/log/student/${id}`"
      :api-type="`/api/liveroom/log/student/${id}?is_show_teacher=1&order[id]=desc`">
      <AppSearch
        slot="search"
        date-type="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
        </el-table>
      </template>
    </AppList>
  </div>
</template>

<script>
  import list from '@/mixins/list';
  export default {
    name: "TeacherStatistics",
    mixins: [list],
    data() {
      return {
        id: this.$route.params.id,
        name: this.$route.params.name,
        mobile: this.$route.params.mobile,
        list: {},
        columns: [],
      }
    },
    computed: {
      searchArr() {
        const column = [
          { prop: 'name', label: '课题名称' },
          { prop: 'number', label: '教室编号' },
          // { prop: 'phone2', label: '课件名称' },
          { prop: 'teacher_name', label: '授课老师' }
        ];
        return [
          {
            componentType: 'AppSearchDate',
            searchType: 'created_at',
          },
          {
            selectValue: [
              { value: 2, name: '直播中' },
              { value: 1, name: '未开始' },
              { value: 3, name: '已结束' },
              { value: 4, name: '老师缺席' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'status',
            placeholder: '请选择直播状态'
          },
          {
            selectValue: [
              { value: 1, name: '班级直播' },
              { value: 2, name: '链接直播' },
              { value: 3, name: '线下课' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'type',
            placeholder: '请选择直播类型'
          },
          {
            selectValue: [
              { value: 1, name: 'AI课件' },
              { value: 2, name: 'AI双师课件' },
              { value: 3, name: '互动课件' },
              { value: 4, name: '其他' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'course_type',
            placeholder: '请选择选课类型'
          },
          {
            selectValue: [
              { value: 1, name: '1v1' },
              { value: 2, name: '1v4' },
              { value: 3, name: '1v6' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'video_type',
            placeholder: '请选择授课班型'
          },
          // {
          //   selectValue: [
          //     { value: 0, name: 'cocos课件' },
          //     { value: 1, name: '云盘文件' }
          //   ],
          //   componentType: 'AppSearchStatus',
          //   searchType: 'is_auth_minipro',
          //   placeholder: '请选择课件班型'
          // },
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
      role() {
        return this.$store.state.user;
      },
    },
    created() {
      this.columns = [
        {
          label: '直播时间',
          width: '180px',
          formatter: row => {
            let time = '';
            switch (row.status) {
              case 1: // 未开始 展示预设直播开始时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 2: // 直播中 展示实际直播开始时间~--
                time = `${row.begin_time} ~ --`;
                break;
              case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                time = `${row.begin_time} ~ ${row.close_time}`;
                break;
              case 4: // 缺课 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 5: // 已取消 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              default:
                break;
            }
            return time
          }
        },
        {
          label: '直播时长',
          formatter: row => {
            const time = this.$setting.setTime(row.act_liveroom_second);
            return `${time.hour}:${time.min}:${time.sec}`
          }
        },
        { prop: 'name', label: '课题' },
        { prop: 'number', label: '教室编号' },
        { prop: 'teacher.name', label: '授课老师' },
        {
          label: '直播类型',
          formatter: row => {
            const type = {
              1: '班级直播间',
              2: '链接直播间',
              3: '线下课'
            };
            return type[row.type]
          }
        },
        {
          label: '选课类型',
          formatter: row => {
            const type = {
              1: 'AI课件',
              2: 'AI双师课件',
              3: '互动课件',
              4: '其他',
              0: '其他'
            };
            return type[row.course_type]
          }
        },
        { prop: 'course_name', label: '课时名称' },
        // { prop: 'name6', label: '课件类型' },
        // { prop: 'name7', label: '课件名称' },
        {
          label: '直播状态',
          formatter: row => {
            const status = {
              1: '未开始',
              2: '直播中',
              3: '已结束',
              4: '缺课',
              5: '已取消'
            };
            return status[row.status]
          }
        },
        // { prop: 'name9', label: '授课班型' },
        { prop: 'student_count', label: '班级学生数' },
        { prop: 'student_count', label: '上课总人次' },
      ];
    },
    methods: {
      // 我的班级入口
      StudentClass() {
        this.$router.push(`/student/class/${this.id}/${this.name}/${this.mobile}`)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 确认授权
      onSubmit() {
        console.log(1)
      }
    }
  }
</script>

<style scoped lang="scss">
  .teacher_statistics {
    .total {
      text-align: left;
      font-size: 16px;
      color: var(--color-primary);
      margin-bottom: 10px;
      span {
        margin: 0 10px;
        b {
          margin: 0 5px;
        }
      }
      .class_btn {
        float: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Student/statistics.vue